import { render, staticRenderFns } from "./CreateProfile.vue?vue&type=template&id=4fff3ae6&scoped=true"
import script from "./CreateProfile.vue?vue&type=script&lang=ts"
export * from "./CreateProfile.vue?vue&type=script&lang=ts"
import style0 from "./CreateProfile.vue?vue&type=style&index=0&id=4fff3ae6&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fff3ae6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4fff3ae6')) {
      api.createRecord('4fff3ae6', component.options)
    } else {
      api.reload('4fff3ae6', component.options)
    }
    module.hot.accept("./CreateProfile.vue?vue&type=template&id=4fff3ae6&scoped=true", function () {
      api.rerender('4fff3ae6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CreateProfile.vue"
export default component.exports